const DiagnosisMultiSelect = ({
  diagnosisList,
  onChange,
  label = "Diagnosis",
  isDisabled = false
}) => {
  const handleDiagnosisChange = (diagnosis, eye) => {
    if (isDisabled) return;
    const updated = { ...diagnosisList };
    updated[diagnosis][eye] = updated[diagnosis][eye] === true ? null : true;
    onChange(updated);
  };

  const hasDiagnosis = (diagnosis) => {
    return diagnosisList[diagnosis]?.OD === true || diagnosisList[diagnosis]?.OS === true;
  };

  return (
    <div className="rounded-lg border p-3 bg-white">

      <div className="flex flex-wrap gap-3">
        {Object.keys(diagnosisList).map((diagnosis) => (
          <div
            key={diagnosis}
            className={`rounded-lg px-3 py-2 border-2 transition-all ${
              hasDiagnosis(diagnosis)
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 bg-gray-50 hover:border-gray-300'
            }`}
          >
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3">
                <span className="text-sm font-medium text-gray-800 flex-1 min-w-0">{diagnosis}</span>

                <div className="flex gap-1 flex-shrink-0">
                  <button
                    onClick={() => handleDiagnosisChange(diagnosis, 'OD')}
                    className={`px-2.5 py-1 rounded-full text-xs font-bold transition-colors whitespace-nowrap ${
                      diagnosisList[diagnosis]?.OD === true
                        ? 'bg-blue-500 text-white'
                        : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
                    }`}
                  >
                    OD
                  </button>
                  <button
                    onClick={() => handleDiagnosisChange(diagnosis, 'OS')}
                    className={`px-2.5 py-1 rounded-full text-xs font-bold transition-colors whitespace-nowrap ${
                      diagnosisList[diagnosis]?.OS === true
                        ? 'bg-blue-500 text-white'
                        : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
                    }`}
                  >
                    OS
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DiagnosisMultiSelect;
